module.exports = __webpack_public_path__ + "img/Jump Casting60.a81a3118.jpg";